import React from 'react'
import { createSelector } from 'reselect'
import { I18n } from 'react-redux-i18n'
import _ from 'lodash'

import parametersSelector from './parameters'

const PAYMENT_TYPE_BALANCE = 'balance'
const PAYMENT_TYPE_PURCHASE = 'purchase'
// const PAYMENT_TYPE_PAYMENT                  = 'payment'
const PAYMENT_TYPE_BUY_TOKEN_BONUS = 'buy_token_bonus'
const PAYMENT_TYPE_PROMOCODE_BONUS = 'promocode_bonus'
const PAYMENT_TYPE_PROMOCODE_BOUNTY = 'promocode_bounty'
const PAYMENT_TYPE_REFERRAL_BOUNTY = 'referral_bounty'
const PAYMENT_TYPE_REFERRAL_USER = 'referral_user'
const PAYMENT_TYPE_REFERRAL_BOUNTY_BALANCE = 'referral_bounty_balance'
const PAYMENT_TYPE_REFERRAL_BONUS_BALANCE = 'referral_bonus_balance'
// const PAYMENT_TYPE_REFUND                   = 'refund'

// const PAYMENT_STATUS_PENDING                = 'pending'
// const PAYMENT_STATUS_COMPLETED              = 'completed'

const payment_types = {
  [PAYMENT_TYPE_BALANCE]: 'Deposit',
  [PAYMENT_TYPE_PURCHASE]: 'Purchase',
  [PAYMENT_TYPE_BUY_TOKEN_BONUS]: 'Bonus',
  [PAYMENT_TYPE_REFERRAL_BOUNTY]: 'Referral',
  [PAYMENT_TYPE_REFERRAL_USER]: 'Referral',
  [PAYMENT_TYPE_REFERRAL_BOUNTY_BALANCE]: 'Referral',
  [PAYMENT_TYPE_REFERRAL_BONUS_BALANCE]: 'Referral',
  [PAYMENT_TYPE_PROMOCODE_BONUS]: 'Promo code bonus',
  [PAYMENT_TYPE_PROMOCODE_BOUNTY]: 'Promo code bonus'
}

const payment_types_collection = types =>
  _.reduce(types, (acc, type) => ({ ...acc, [type]: payment_types[type] }), {})

const paymentsSelector = state => state.users.current.payments

const getColumns = config_parameters => [
  {
    Header: 'Date',
    accessor: 'date',
    id: 'created_at'
  },
  {
    Header: 'Type',
    accessor: 'type'
  },
  {
    Header: 'Amount',
    accessor: 'amount'
  },
  {
    Header: 'Currency',
    accessor: 'currency'
  },
  {
    Header: `${config_parameters['coin.rate_currency']} Amount`,
    accessor: 'ico_currency_amount',
    Cell: row => (row.value > 0 ? row.value : '—')
  },
  {
    Header: 'Tokens',
    accessor: 'tokens',
    Cell: row => row.value || '—'
  },
  {
    Header: 'Description',
    accessor: 'description',
    sortable: false
  },
  {
    Header: 'Actions',
    id: 'actions',
    sortable: false,
    accessor: row => row,
    Cell: row => (
      <span>
        {row.value.contract_uri && (
          <a href={row.value.contract_uri} title="Donwload Contract">
            <i className="fa fa-handshake-o" aria-hidden="true" />
          </a>
        )}
        {row.value.invoice_uri && (
          <a href={row.value.invoice_uri} title="Donwload Invoice">
            <i className="fa fa-money" aria-hidden="true" />
          </a>
        )}
        {!row.value.contract_uri && !row.value.invoice_uri && '—'}
      </span>
    )
  }
]

export default createSelector(
  parametersSelector,
  paymentsSelector,
  (config_parameters, { json: data, headers, loading, search }) => ({
    filter: payment_types_collection(headers && JSON.parse(headers.get('x-payment-types'))),
    search,
    total: (headers && parseInt(headers.get('x-total'), 10)) || 0,
    loading,
    defaultSorted: [{ id: 'created_at', desc: true }],
    defaultPageSize: search.per_page,
    pages: headers && Math.ceil(headers.get('x-total') / headers.get('x-per-page')),
    columns: getColumns(config_parameters),
    data: _.map(data, payment => ({
      ...payment,
      date: I18n.l(payment.created_at, { dateFormat: 'date.long' }),
      type: payment_types[payment.type],
      type_origin: payment.type
    }))
  })
)



// WEBPACK FOOTER //
// ./src/selectors/payments.js